import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseEscapedHtml',
  standalone: false,
})
export class ParseEscapedHtmlPipe implements PipeTransform {
  transform(content: string): string {
    const text = document.createElement('textarea');
    text.innerHTML = content;
    return text.value;
  }
}
